import PropTypes from 'prop-types';

export default {
  contractRequirements: PropTypes.array,
  additionalInformation: PropTypes.array,
  handleAdditionalInfoUpdates: PropTypes.func,
  formValues: PropTypes.object,
};
